<div class="sidebar-list" [class.sidebar-list--compact]="resolvedVariant() === 'compact'">
  @if (showHeader()) {
    <div class="sidebar-list__header">
      @if (headerTitle(); as titleText) {
        <span class="sidebar-list__title">{{ titleText | translate }}</span>
      }
      @if (headerCreateLabel(); as createLabel) {
        <button
          type="button"
          hlmBtn
          variant="ghost"
          class="sidebar-list__create-icon"
          [attr.aria-label]="createLabel | translate"
          (click)="onCreateClick()"
        >
          <ocp-themed-icon name="plus-circled-bold.svg" [size]="14" />
        </button>
      }
    </div>
  }

  <ul class="sidebar-list__items">
    @for (item of viewItems(); track item.id) {
      <li class="sidebar-list__item" [class.sidebar-list__item--selected]="item.selected">
        <a
          class="sidebar-list__item-link"
          [routerLink]="item.routerLink"
          [queryParams]="item.queryParams"
          [queryParamsHandling]="item.queryParamsHandling || 'preserve'"
          [attr.aria-selected]="item.ariaSelected"
          (click)="onItemClick(item.sourceItem)"
          (keydown.space)="$event.preventDefault(); onItemClick(item.sourceItem)"
        >
          @if (item.showSelectedIcon) {
            <ocp-themed-icon name="checkmark.svg" class="sidebar-list__check" />
          }

          @if (item.showSpacer) {
            <span class="sidebar-list__spacer"></span>
          }

          @if (item.showAvatar) {
            <ocp-avatar
              [userInitials]="item.initial"
              [colorSeed]="item.colorSeed ?? item.id"
              size="md"
              singleInitial
            />
          }

          <span class="sidebar-list__label" ocpTruncate>{{ item.label | translate }}</span>
        </a>
      </li>
    }
  </ul>

  @if (footerActions().length) {
    <div class="sidebar-list__footer">
      @for (action of footerActions(); track action.id) {
        <button
          type="button"
          hlmBtn
          variant="ghost"
          class="sidebar-list__create-btn sidebar-list__footer-action"
          [routerLink]="action.routerLink"
          queryParamsHandling="preserve"
          [attr.aria-label]="action.label | translate"
          (click)="onResolvedFooterActionClick(action)"
        >
          <ocp-themed-icon [name]="action.icon" size="14" />
          {{ action.label | translate }}
        </button>
      }
    </div>
  }
</div>
